/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../../hooks/useForm';
import { shallowEqual, useSelector } from 'react-redux';
import { getTaxCompaniesInfo } from '../../../apis/tax-portal';
import { isEmpty } from '../../../utils/lodashExtend';
import Filters from '../../Filters';
import { getParams } from '../../../utils/params';
import { ControlTable } from '../../Table';
import { comma } from '../../../utils/number';
import TaxCompaniesInfoDetail from './TaxCompaniesInfoDetail';
import { findIndex } from 'lodash';

const TaxCompaniesInfo = () => {
  const { taxContactType } = useSelector(
    (store) => ({
      taxContactType: store.TaxPortal.taxContactType,
    }),
    shallowEqual
  );
  const [filters] = useState([
    { title: "상호명 또는 사업자번호", key: "search.keyword" }
  ]);

  const [detailOpen, setDetailOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);

  const [type, setType] = useState('');

  const [params, setParams] = useState(null);

  const [sortFields, setSortFields] = useState([
    { key: 'name', order: '' },
    { key: 'comNum', order: '' },
    { key: 'unreadCounselings', order: '' },
    { key: 'unreadCounselingToCompanies', order: '' },
    { key: 'mappings', order: '' },
    { key: 'mappingAndUseConfirms', order: '' },
    { key: 'useConfirms', order: '' },
  ]);

  const [fields, setFields] = useState([]);

  useEffect(() => {
    const _fields = [
      {
        title: "상호명",
        key: "name",
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        title: "사업자등록번호",
        key: "comNum",
        transform: "comNum",
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        title: "미열람 상담(답글포함)",
        key: "unreadCounselings",
        onValue: (v, _f, d) => (
          <span className="cursor-pointer" onClick={() => {
            setDetailOpen(true);
            setSelectedItem({
              ...d,
              modalTitle: "미열람 상담(답글포함)"
            });
            setType("unreadCounselings");
            setParams({
              readType: "tax_read",
              order: [{ "createdTime": "desc" }],
              careCompanyIdx: d.idx,
            });
          }}>
            {comma(v || 0)}
          </span>
        ),
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        title: "업체의 미열람 상담(답글포함)",
        key: "unreadCounselingToCompanies",
        onValue: (v, _f, d) => (
          <span className="cursor-pointer" onClick={() => {
            setDetailOpen(true);
            setSelectedItem({
              ...d,
              modalTitle: "업체의 미열람 상담(답글포함)"
            });
            setType("unreadCounselingToCompanies");
            setParams({
              readType: "care_read",
              order: [{ "createdTime": "desc" }],
              careCompanyIdx: d.idx,
            });
          }}>
            {comma(v || 0)}
          </span>
        ),
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        // title: "거래처 매핑안된 내역, 확인요청",
        title: <>
          <span className="border-right pr-10">거래처 매핑안된내역</span>
          <span className="ml-10">확인요청</span>
        </>,
        key: "mappings",
        onValue: (v, _f, d) => (
          <>
            <span
              className="cursor-pointer border-right pr-10"
              onClick={() => {
                setDetailOpen(true);
                setSelectedItem({
                  ...d,
                  modalTitle: "거래처 매핑안된 내역"
                });
                setParams({ companyIdx: d.idx });
                setType("mappings");
              }}>
              <span className="font-bold">매핑내역: </span>
              {comma(v || 0)}
            </span>
            <span
              className="cursor-pointer ml-10"
              onClick={() => {
                setDetailOpen(true);
                setSelectedItem({
                  ...d,
                  modalTitle: "거래처 매핑안된 내역 확인 요청"
                });
                setParams({ companyIdx: d.idx });
                setType("mappingAndUseConfirms");
              }}>
              <span className="font-bold">확인요청: </span>
              {comma(d.mappingAndUseConfirms || 0)}
            </span>
          </>
        ),
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        // title: "카테고리 매핑안된 내역",
        title: <>
          <span className="border-right pr-10">카테고리 매핑안된내역</span>
          <span className="ml-10">확인요청</span>
        </>,
        key: "categoryMappings",
        onValue: (v, _f, d) => (
          <>
            <span
              className="cursor-pointer border-right pr-10"
              onClick={() => {
                setDetailOpen(true);
                setSelectedItem({
                  ...d,
                  modalTitle: "카테고리 매핑안된 내역"
                });
                setParams({ companyIdx: d.idx });
                setType("mappings");
              }}>
              <span className="font-bold">매핑내역: </span>
              {comma(v || 0)}
            </span>
            <span
              className="cursor-pointer ml-10"
              onClick={() => {
                setDetailOpen(true);
                setSelectedItem({
                  ...d,
                  modalTitle: "카테고리 매핑안된 내역 확인 요청"
                });
                setParams({ companyIdx: d.idx });
                setType("categoryMappingAndUseConfirms");
              }}>
              <span className="font-bold">확인요청: </span>
              {comma(d.categoryMappingAndUseConfirms || 0)}
            </span>
          </>

          // <span className="cursor-pointer" onClick={() => {
          //   setDetailOpen(true);
          //   setSelectedItem({
          //     ...d,
          //     modalTitle: "카테고리 매핑안된 내역"
          //   });
          //   setParams({ companyIdx: d.idx });
          //   setType("categoryMappings");
          // }}>
          //   {comma(v || 0)}
          // </span>
        ),
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
      {
        title: "내역 확인 요청",
        key: "useConfirms",
        onValue: (v, _f, d) => (
          <span className="cursor-pointer" onClick={() => {
            setDetailOpen(true);
            setSelectedItem({
              ...d,
              modalTitle: "내역 확인 요청"
            });
            setParams({ companyIdx: d.idx });
            setType("useConfirms");
          }}>
            {comma(v || 0)}
          </span>
        ),
        sort: (key) => handleSort(key),
        order: (key) => orderKey(key)
      },
    ];
    setFields(_fields);
  }, [sortFields]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
    setOrderBy,
  } = useForm({
    offset: 0,
    limit: 10,
    order: [{ "mappings": "desc" }],
  });

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);


  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField?.order;
  };


  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];

    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const submit = (form) => {
    setIsLoading(true);
    getTaxCompaniesInfo({
      ...getParams(form),
      taxSearchType: taxContactType,

    }).then(res => {
      setList(res?.companies || []);
      setTotal(res?.total || 0);
    }).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!isEmpty(taxContactType)) {
      setSubmit(submit);
      submit(form);
    }
  }, [taxContactType]);

  const close = () => {
    reSubmit();
    setType('');
    setParams({});
  };

  return (
    <>
      <Filters
        filters={filters}
        isLoading={isLoading}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideControlHeader={true}
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={false}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
      />

      <TaxCompaniesInfoDetail
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={close}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        params={params}
        setParams={setParams}
        detailType={type}
      />
    </>
  );
};

export default TaxCompaniesInfo;